enum MessageType {
  Medical = 'medical',
  SMS = 'sms',
  StaffNote = 'staffNote',
  Support = 'support'
}

enum Status {
  Fulfilled = 'fulfilled',
  Idle = 'idle',
  Pending = 'pending',
  Rejected = 'rejected'
}

enum StaffNotesEvents {
  LabRequest = 'labRequest'
}

enum MessageEvents {
  AppointmentCancelled = 'appointmentCancelled',
  AppointmentComplete = 'appointmentComplete',
  AppointmentCreated = 'appointmentCreated',
  AppointmentMissed = 'appointmentMissed',
  LabRequest = 'labRequest'
}

enum MessageTemplates {
  Internal = 'internal',
  Patient = 'patient'
}

export { MessageType, Status, StaffNotesEvents, MessageEvents, MessageTemplates };
